import React, { FC } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AgentRequestResponse } from '../../../structures/response/AgentRequestResponse';
import MfButton from '../../UI/Button/MfButton';
import { confirmPledgeByTransport } from '../../../api/agent';

interface Props {
  open: boolean;
  onClose: () => void;
  request: AgentRequestResponse | null;
  onConfirmed: () => void;
}

const PledgeConfirmDialog: FC<Props> = ({
  onClose,
  open,
  request,
  onConfirmed,
}) => {
  const theme = useTheme();
  const fs = useMediaQuery(theme.breakpoints.down('md'));

  const handleConfirm = async () => {
    if (request?.id) {
      try {
        await confirmPledgeByTransport(request.id);
        onConfirmed();
        onClose();
      } catch (e) {
        console.log(e); // todo: remove this line
      }
    }
  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      fullScreen={fs}
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Подтверждение наличия залога</DialogTitle>
      <DialogContent>
        <div>
          <p>
            К сожалению, клиент не прошёл автоматическую проверку по минимальным
            требованиям для займа без залога. Но мы можем предложить займ под
            залог транспортного средства.
          </p>
          <p>У клиента есть ТС для залога?</p>
        </div>
      </DialogContent>
      <DialogActions>
        <MfButton variant="contained" color="primary" onClick={handleConfirm}>
          Да
        </MfButton>
        <MfButton variant="contained" color="secondary" onClick={onClose}>
          Нет
        </MfButton>
      </DialogActions>
    </Dialog>
  );
};

export default PledgeConfirmDialog;
